import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "share-widget";
config.shape = `<path fill="var(--fill)" stroke="none" fill-rule="evenodd" d="M17.084 8.001L9.918 15.15a.5.5 0 0 1-.853-.354v-4.648c-6.15 0-9.032 5.919-9.032 5.919S-1.047 6.2 9.065 4.72V.5a.5.5 0 0 1 .853-.354l7.166 7.147a.5.5 0 0 1 0 .708z"/>`;
let ShareWidget = new SvgFactory(config);

export default ShareWidget;
